import React from 'react';
import PropTypes from 'prop-types';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import { BLACK, PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';
import {
  epochToDateInReadableFormat,
  epochToDayOfWeek,
  epochToTimeInReadableFormat,
} from '../../../../utils';

const TimecardHistoryHeader = ({ candidateName, placementName, placementStart, placementEnd }) => (
  <Box sx={{ padding: '48px 0px' }}>
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Typography sx={{ fontFamily: PRIMARY_FONT[700], color: BLACK[100], fontSize: '24px' }}>
        {LanguageConverterV2('timekeeping.workerTimecard.timecardHistory.title')}
      </Typography>
      <Typography
        sx={{
          fontFamily: PRIMARY_FONT[700],
          color: PRIMARY_PURPLE[70],
          fontSize: '24px',
          textDecoration: 'underline',
        }}
      >
        {candidateName}
      </Typography>
    </Box>
    <Box>
      <Typography
        sx={{ fontFamily: PRIMARY_FONT[300], color: BLACK[100], fontSize: '20px' }}
      >{`${epochToDayOfWeek(placementStart)} ${epochToDateInReadableFormat(
        placementStart
      )}  - ${placementName} ${epochToTimeInReadableFormat(
        placementStart
      )} - ${epochToTimeInReadableFormat(placementEnd)}`}</Typography>
    </Box>
  </Box>
);

TimecardHistoryHeader.propTypes = {
  candidateName: PropTypes.string,
  placementName: PropTypes.string,
  placementStart: PropTypes.number,
  placementEnd: PropTypes.number,
};
export default TimecardHistoryHeader;
